import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/')({
  beforeLoad: () => {
    return redirect({ to: '/dashboard' });
  },
});
